import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      header: {
        marginTop: theme.spacing(3),
      },
      title: {
        marginBottom: theme.spacing(3),
      },
      subtitle: {
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 300,
        fontSize: 24,
        lineHeight: '32px',
        marginBottom: theme.spacing(1),
      },
    }),
  { name: 'HomeAssessor' }
);
